import { render, staticRenderFns } from "./CsrProcessCreateEdit.vue?vue&type=template&id=63c2c72a&scoped=true&"
import script from "./CsrProcessCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CsrProcessCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CsrProcessCreateEdit.vue?vue&type=style&index=0&id=63c2c72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2c72a",
  null
  
)

export default component.exports